import { createFileRoute } from '@tanstack/react-router'
import { SiteViewPageContainer } from 'pages/overview/SiteViewPageContainer'
import { overviewSearchParams } from 'routes/overview/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId, healthConditions } = Route.useSearch()

  return (
    <SiteViewPageContainer
      organizationId={orgId}
      siteId={siteId}
      healthConditions={healthConditions}
    />
  )
}

export const Route = createFileRoute('/overview/')({
  component: RouteComponent,
  validateSearch: overviewSearchParams,
  staticData: {
    title: 'Site Overview',
  },
})
